import React from 'react';
import { Alert, Link, Typography } from '@one-thd/sui-atomic-components';
import InvalidItemsModal from '../shared/invalid-items-modal/InvalidItemsModal';
import { getErrorModalBodyText } from '../shared/invalid-items-modal/InvalidItemsModalHelper';
import { PolicyValidatorErrors } from '../../utils';

interface PolicyValidatorAlertProps {
  alert: PolicyValidatorErrors;
  clearAlert: () => void;
}

const PolicyValidatorAlert = ({
  alert,
  clearAlert,
}: PolicyValidatorAlertProps) => {
  // We display a modal when a return either has multiple shipping addresses or all items are HRTV ineligible
  if (
    alert === PolicyValidatorErrors.MULTI_SHIPMENTS ||
    alert === PolicyValidatorErrors.HAS_INELIGIBLE_ITEMS
  ) {
    const closeModal = () => {
      window.scrollTo(0, 0);
      clearAlert();
    };
    return (
      <InvalidItemsModal
        title="We’re Unable to Process This Return"
        body={getErrorModalBodyText(alert)}
        primaryButtonText="Close"
        secondaryButtonText="Back to Order Details Page"
        onPrimaryClick={closeModal}
        onSecondaryClick={() => window.history.back()}
        onClose={closeModal}
      />
    );
  }

  // Otherwise, we display an inline alert for rest of the errors
  const ineligibleItemsErrorMessage = (
    <>
      We&apos;re sorry. The items below can&apos;t be returned. See our{' '}
      <Link href="https://www.homedepot.com/c/Pro_Return_Policy">
        Returns Policy
      </Link>{' '}
      for more options.
    </>
  );
  const networkErrorMessage =
    'We’re sorry. There was a temporary technical error. Please try again shortly.';
  const weightLimitErrorMessage = (
    <>
      UPS drop-off returns can&apos;t exceed 150 lbs. You can reduce the
      selected return quantities. Or you can return all items in store.
    </>
  );
  const messageMapper = {
    [PolicyValidatorErrors.NETWORK]: networkErrorMessage,
    [PolicyValidatorErrors.GENERIC]: ineligibleItemsErrorMessage,
    [PolicyValidatorErrors.SSR_UPS_ERR_1002]: weightLimitErrorMessage,
  };
  return (
    <div className="sui-mb-4">
      <Alert status="error" size="large">
        <Typography variant="body-base">
          {messageMapper[alert as keyof typeof messageMapper] ||
            ineligibleItemsErrorMessage}
        </Typography>
      </Alert>
    </div>
  );
};

export default PolicyValidatorAlert;
